export enum HubChannels {
  COMMMENTS = "comments",
  TICKETS = "tickets",
  EVENTS = "events"
}
